import React, { useState } from "react";
import Button from "../../components/Button/Button";
import BackButton from "../../components/BackButton/BackButton";

function ExteriorConditions({ onSelect, onBack }) {
  const [selectedCondition, setSelectedCondition] = useState(null);

  const conditions = [
    {
      id: 1,
      name: "✅ Sí",
      value: true,
    },
    {
      id: 2,
      name: "❌ No",
      value: false,
    },
  ];

  const handleSelect = (value) => {
    setSelectedCondition(value);
    onSelect(value);
  };

  return (
    <div className="goodCondition">
      <h2>¿El exterior de tu teléfono está en buen estado?</h2>
      <p className="sub-description">
        <ul>
          <li>Está libre de grietas importantes, roturas y rayones.</li>
          <li>Si hay vidrio en la parte posterior, no está roto.</li>
        </ul>
      </p>
      <div className="buttonsContainer">
        {conditions.map((item) => (
          <Button
            key={item.id}
            type={selectedCondition === item.value ? "fullBlack" : "full"} // Cambia el estilo dinámicamente
            onClick={() => handleSelect(item.value)}
          >
            {item.name}
          </Button>
        ))}
      </div>
      {/* <BackButton onClick={onBack} /> */}
    </div>
  );
}

export default ExteriorConditions;
